import { ChangeDetectionStrategy, Component, HostBinding, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Observable, Subject, combineLatest } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FiAiChatHelperService } from '@fi-shared/fi-ai-chat/fi-ai-chat-helper.service';
import { FiChatHelperService } from '@fi-shared/fi-chat/fi-chat-helper.service';

const AI_BUTTON_DEFAULT_RIGHT = 116; // left of fi-chat-button (right:48 + 56 fab + 12 gap)
const AI_BUTTON_GAP = 15;

@Component({
    selector: 'fi-ai-chat-button',
    template: `
        @if (isAvailable$ | async) {
            <button
                mat-fab
                color="primary"
                class="ContrastBackgroundColor ai-chat-mat-icon-button"
                (click)="onOpenAiChatClick()"
                [attr.aria-label]="'ai.chat_open' | fiAppText"
            >
                <mat-icon class="fas fa-robot"></mat-icon>
            </button>
        }
    `,
    styleUrls: ['./fi-ai-chat-button.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-ai-chat-button' },
    standalone: false,
})
export class FiAiChatButtonComponent implements OnInit, OnDestroy {
    @HostBinding('class.hidden') hidden = false;
    @HostBinding('style.right.px') rightOffset = AI_BUTTON_DEFAULT_RIGHT;

    readonly isAvailable$: Observable<boolean>;

    constructor(
        private fiAiChatHelperService: FiAiChatHelperService,
        private fiChatHelperService: FiChatHelperService,
    ) {
        this.isAvailable$ = this.fiAiChatHelperService.isAvailable$;
    }

    ngOnInit(): void {
        this.fiAiChatHelperService.ensureAvailabilityLoaded();

        combineLatest([this.fiChatHelperService.chatZoneWidth$, this.fiAiChatHelperService.isOpen$])
            .pipe(takeUntil(this.ngOnDestroy$))
            .subscribe(([chatZoneWidth, aiOpen]) => {
                this.hidden = aiOpen;
                this.rightOffset = Math.max(AI_BUTTON_DEFAULT_RIGHT, chatZoneWidth + AI_BUTTON_GAP);
            });
    }

    onOpenAiChatClick(): void {
        this.fiAiChatHelperService.open();
    }

    private ngOnDestroy$ = new Subject<void>();
    ngOnDestroy(): void {
        this.ngOnDestroy$.next();
        this.ngOnDestroy$.complete();
    }
}
